/**
 * Entry point for the runtime auth JS API bundle (`auth-runtime-api.js`), exposed on published /
 * Vibe sites as `window['auth-runtime-api'].default`. Mirrors ms-sitecollections' public-api entry.
 */
import { applyNewPassword, logout, me, requestPasswordReset, signIn, signUp } from './authApi';
import { signInWithProvider } from './signInWithProvider';

const api = {
    signUp,
    signIn,
    logout,
    me,
    requestPasswordReset,
    applyNewPassword,
    signInWithProvider,
};

export default api;
